/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(".collection-add-to-cart").click(function() {
  var $form = $(this).parents("form");
  var id = $form.find("[name='id']").val();
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: id,
      quantity: 1
    },
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: id,
          quantity: 1
        }
      }));
    }
  });
});

$("button[data-action='select-value']").on('click', function() {
  setTimeout(function() {
    $(".ProductForm [name='id']").trigger("change");
  }, 100);
});

$(".ProductForm [name='id']").on("change", function() {
  var id = $(this).val();
  $(this).parents(".Product__Wrapper").find(".ProductItem__Label--onSale").css("display", "none");
  $(this).parents(".ProductItem__Wrapper").find(".ProductItem__Label--onSale").css("display", "none");
  $(".ProductItem__Label--onSale[data-variant-id='" + id + "']").css("display", "block");
});